import { t } from '@avalara/bat-apps-shared/i18n';
import { SAlert, SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { ExemptionsPlanClientDetails, OfferPlanClientDetails } from '../../../../../../types/offers';
import { embeddedViewRequested } from '../../../../lib/helpers';
import { selectIsNonAdmin, selectState } from '../../../../selectors';
import { purchaseDeflectionWording } from '../../../helpers';
import OfferBox from '../../box';
import NextButton from '../shared/next-button';
import ExemptionsOfferPlan from './exemptions-offer-plan';

type Props = {
  plans: Array<OfferPlanClientDetails & ExemptionsPlanClientDetails>;
};

const ExemptionsPlanSelect = ({ plans }: Props) => {
  const [selectedPlanName, selectPlanName] = useState('');
  const isNonAdmin = useSelector(selectIsNonAdmin);
  const {
    account: { isLoggedIn },
  } = useSelector(selectState);

  useEffect(() => {
    if (plans.length) selectPlanName(plans[0].name); // default to first plan selected
  }, [plans]);

  return (
    <>
      {isLoggedIn && isNonAdmin && (
        <SAlert status='info' noDismiss={true} className='margin-all-sm'>
          <div>{purchaseDeflectionWording}</div>
        </SAlert>
      )}
      <OfferBox isEmbedded={embeddedViewRequested()} className='margin-all-sm pad-all-sm'>
        <SRow>
          <SCol>
            <p className='margin-top-sm text-md'>{t('client.general.choose-a-plan-that-works-for-your-business')}</p>
          </SCol>
        </SRow>

        <SRow>
          {plans?.map((plan) => (
            <SCol key={plan.name} span='auto' className='flex justify-content-center'>
              <ExemptionsOfferPlan
                plan={plan}
                selected={selectedPlanName === plan.name}
                onSelect={() => selectPlanName(plan.name)}
                isDisabled={isLoggedIn && isNonAdmin}
              />
            </SCol>
          ))}
        </SRow>

        <SRow>
          <SCol span='auto' className='flex align-items-center justify-content-space'>
            <p className='margin-right-lg' data-ref='exemptions.plan-select.need-help'>
              {t('client.general.need-help-deciding-on-a-plan')}
            </p>

            <NextButton selectedPlanName={selectedPlanName} disableButton={isLoggedIn && isNonAdmin} />
          </SCol>
        </SRow>
      </OfferBox>
    </>
  );
};

export default ExemptionsPlanSelect;
